import axiosClient from './axios';

export interface ArticleMetadata {
  title?: string;
  authors?: string[];
  journal?: string;
  year?: number;
  pmid?: string;
}

export interface StructuredData {
  background: string;
  objective: string;
  methods: string;
  results: string;
  limitations: string;
  population: string | null;
  study_type: string | null;
}

export interface SummarizeResponse {
  summary_html: string;
  structured: StructuredData;
  model_name: string;
  created_at: string;
}

export interface ArticleBrief {
  title: string;
  year: number | null;
  abstract: string;
}

export interface SOTAArticleBrief {
  title: string;
  year: number | null;
  main_finding: string;
}

export interface SOTAResponse {
  sota_summary_html: string;
  articles_brief: SOTAArticleBrief[];
  gaps: string;
  model_name: string;
  created_at: string;
}

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface ChatResponse {
  answer: string;
  model_name: string;
  created_at: string;
}

export const summarizeArticle = async (
  articleId?: string,
  abstract?: string,
  fulltext?: string,
  metadata?: ArticleMetadata
): Promise<SummarizeResponse> => {
  const response = await axiosClient.post('medinsight/llm/summarize', {
    articleId,
    abstract,
    fulltext,
    metadata,
  });
  return response.data.result;
};

export const generateSOTA = async (
  projectId: string,
  focus?: string
): Promise<SOTAResponse> => {
  const response = await axiosClient.post('medinsight/llm/sota', {
    projectId,
    focus,
  });
  return response.data.result;
};

export const chatWithArticles = async (
  history: ChatMessage[],
  projectId?: string,
  signal?: AbortSignal
): Promise<ChatResponse> => {
  const response = await axiosClient.post('medinsight/llm/chat', {
    history,
    projectId,
  }, {
    signal,
  });
  return response.data.result;
};
